import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { showLoginAction } from "./actions";
import { selectSubscriptionLevel } from "./selectors";
import { makeOptionalAuthRequest } from "./http";

export const useAuthErrorHandler = () => {
  const dispatch = useDispatch();
  const handleError = useCallback(
    (error, callback) => {
      if (error?.response?.status === 401) {
        callback();
        dispatch(showLoginAction());
      }
    },
    [dispatch, showLoginAction]
  );
  return handleError;
};

export const useCreateConfigModal = () => {
  const [createAlertSymbol, setCreateAlertSymbol] = useState();
  const clearCreateAlertSymbol = useCallback(
    () => setCreateAlertSymbol(undefined),
    [setCreateAlertSymbol]
  );
  const addAlert = useCallback((symbol) => setCreateAlertSymbol(symbol), [
    setCreateAlertSymbol,
  ]);

  return {
    addAlert,
    createAlertSymbol,
    clearCreateAlertSymbol,
  };
};

export const useShowAds = () => {
  const subscriptionLevel = useSelector(selectSubscriptionLevel);

  const showAds = subscriptionLevel == null;
  return {
    showAds,
    showVideoAds: false,
  };
};

export const useDataSelectors = () => {
  const [showFee, setFee] = useState(true);
  const [showAvailable, setAvailable] = useState(true);
  const [showClose, setClose] = useState(false);
  const [showVolume, setVolume] = useState(false);

  return {
    showFee,
    setFee,
    showAvailable,
    setAvailable,
    showClose,
    setClose,
    showVolume,
    setVolume,
  };
};
